import React from "react";
import { Button } from "antd";
import { signInWithRedirect } from "aws-amplify/auth";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const provider = { custom: "microsoft-test" };
  const navigate = useNavigate();

  const handleSignIn = async () => {
    try {
      await signInWithRedirect({ provider });
    } catch (error) {
      console.error(error);
      if (error.name === "UserAlreadyAuthenticatedException") {
        console.error(error);
        navigate("/initialize");
      }
    }
  };

  return (
    <div
      style={{
        backgroundImage: 'url("/HomePageBackgroundPic.png")',
        height: "100vh",
        width: "100vw",
        position: "relative",
        backgroundColor: "#1f1e1e",
        backgroundPosition: "right",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        overflow: "hidden",
        textAlign: "center",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          src="/RfSonsLogoLight.png"
          alt="logo"
          style={{ width: "30vw", paddingBottom: "20vh", paddingTop: "15vh" }}
        />
        <Button type="primary" onClick={() => handleSignIn()}>
          Login with your Microsoft Account
        </Button>
      </div>
    </div>
  );
};

export default Login;
